// shim that gets loaded before apps using layout
import '../../assets/javascripts/v2/modules/cerego-layout-app.js';
